import { get, post, put } from '../Services/http';
export const ORGANIZATIONS_GET = 'ORGANIZATIONS_GET';
export const loadOrganization = (name) => (dispatch) => {
  return get('/api/organizations/getall?name=' + name)
    .then((response) => response.json())
    .then((organizations) => {
      dispatch(receive(organizations));
    });
};
export const changeOrganization = (organizationId) => (dispatch) => {
  return post('/api/organizations/changeOrganization', { organizationId }).then(
    (response) => {
      response.json();
    }
  );
};
export const receive = (organizations) => ({
  type: ORGANIZATIONS_GET,
  payload: organizations,
});
